
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { LoginCardComponent } from './layouts/login-card/login-card.component';

@Component({
  selector: 'app-not-authorized-container',
  template: `
    <app-login-card>
      <router-outlet></router-outlet>
    </app-login-card>
  `,
  styles: [
    `
      :host {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  imports: [RouterModule, LoginCardComponent],
  standalone: true,
})
export class NotAuthorizedContainerComponent {
  private router = inject(Router);

  get title() {
    const path = this.router.url.split('/')[1];
    switch (path) {
    case 'login-form':
      return '';
    case 'reset-password':
      return 'Reset Password';
    case 'create-account':
      return 'Sign Up';
    case 'change-password':
      return 'Change Password';
    }
  }

  get description() {
    const path = this.router.url.split('/')[1];
    switch (path) {
    case 'reset-password':
      return 'Please enter the email address that you used to register, and we will send you a link to reset your password via Email.';
    }
  }
}

export class NotAuthorizedContainerModule {}
